import { makeStyles } from 'tss-react/mui';

const name = 'ChainTypeTab';

export const useChainTypeTabStyles = makeStyles({ name })(() => ({
  root: {
    '&': {
      height: 30,
      minHeight: 'unset',
      boxShadow: 'none',

      borderRadius: 7, // ex 10

      fontSize: 14,
      fontWeight: 500,
      lineHeight: '143%',
    },
  },
}));
